import React from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import styles from './checkbox-label.module.css';

type CheckboxLabelProps = {
	label: string;
	checked: boolean;
	disabled?: boolean;
	onCheckedChange: (newValue: boolean) => void;
};
export const CheckboxLabel = (props: CheckboxLabelProps) => {
	return (
		<Label
			className={`hover:bg-accent/50 flex  gap-3 rounded-lg border p-3 has-[[aria-checked=true]]:border-blue-600 has-[[aria-checked=true]]:bg-blue-50 dark:has-[[aria-checked=true]]:border-blue-900 dark:has-[[aria-checked=true]]:bg-blue-950 ${styles['checkbox-label']}`}
		>
			<Checkbox
				id="toggle-2"
				checked={props.checked}
				onCheckedChange={(e) => props.onCheckedChange(Boolean(e))}
				disabled={props.disabled}
			/>
			<p className="text-sm leading-none font-medium">{props.label}</p>
		</Label>
	);
};
